import compose from "ramda/es/compose";
import curry from "ramda/es/curry";
import filter from "ramda/es/filter";
import { Children } from 'react';
export default curry((filterFn, children)=>compose(filter(filterFn), Children.toArray)(children));
